module.exports = __webpack_public_path__ + "static/media/facebook.60a4318d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/facebook.svg
 ** module id = 216
 ** module chunks = 0
 **/